// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3vm1s","additionalInfo":"AgreementModal_additionalInfo__3UbK5"};